module.exports = __webpack_public_path__ + "img/keyboard_S.8ea224d5.png";